import { Typography } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { OLPaper } from "OLPaper";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    section: {
      marginBottom: theme.spacing(12),
    },
    error: {
      color: theme.red500,
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": { marginTop: 0 },
    },
  }),
);

interface Props {
  title?: string | React.ReactNode;
  subTitle?: React.ReactNode;
  sectionError?: string[] | string;
  children: React.ReactNode;
  isError?: boolean;
  isLoading?: boolean;
  noBorder?: boolean;
  noPadding?: boolean;
}

export const FormSection = ({
  children,
  isLoading,
  noBorder,
  noPadding,
  sectionError,
  subTitle,
  title,
}: Props) => {
  const classes = useStyles();
  const showSectionError = sectionError && typeof sectionError[0] === "string";

  return (
    <section className={classes.section}>
      {title && (
        <Typography fontSize="16px" mb="16px" fontWeight={500}>
          {title}
        </Typography>
      )}
      {isLoading ? (
        <Skeleton height={100} />
      ) : (
        <>
          {subTitle}
          {showSectionError && (
            <Typography className={`${classes.error} Mui-error`}>
              {sectionError.toString()}
            </Typography>
          )}
          <OLPaper noPadding={noPadding} noBorder={noBorder}>
            {children}
          </OLPaper>
        </>
      )}
    </section>
  );
};
